import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getClubOptions, getClubValue } from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import MultiSelectDropdown from '../MultiSelectComponent/MultiSelectPrimary/selectDropDownComponent';
import { SingleOption } from '../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';
import { setClubValue } from '../../../redux/reducers/licenceAnalytics';

const ClubFilterComponent: React.FC = () => {
  const activeClubId = useSelector((state:any) => state?.clubDetails?.id);
  const isAdmin = useSelector((state:any) => state?.common?.isAdmin);
  const options:any = useSelector(getClubOptions);
  // const myClubs = useSelector((state: any) => state.common.myClubs);
  const value:any = useSelector(getClubValue);
  const dispatch = useDispatch();
  const [t] = useTranslation();

  const onChange = (newValue: SingleOption | undefined): void => {
    dispatch(setClubValue({ newValue }));
  };

  useEffect(() => {
    const club = options.filter((option:any) => option.id == activeClubId)?.[0];
    if (!isAdmin) {
      dispatch(setClubValue({ newValue: club }));
    }
  }, [options, activeClubId]);

  return (
    <MultiSelectDropdown
      title={t('DC_5_CLUB')}
      options={isAdmin ? options : options.filter((option:any) => option.id == activeClubId)}
      value={value}
      getId={(obj: SingleOption | any): string => obj?.id}
      getLabel={(obj: SingleOption): string => obj?.name}
      onChange={onChange}
      width="100%"
      rootCss={{ width: '100%' }}
      addNone
    />
  );
};

export default ClubFilterComponent;
